import { IObservableArray, observable, runInAction } from 'mobx';
import { request } from '../../services/request';
import { PaginatedDataStore } from '../paginated-data.store';
import { Post } from './trade-sharing.store';
import {
    AbstractSocialTradingStore,
    GetFilterValuesResponse,
    PaginationInterface,
} from './abstract-social-trading.store';

export interface SignalInterface {
    id: number;
    user_id: number;
    seasonal_potential: string;
    symbol: string;
    symbol_name: string;
    time_frame: string;
    signal_name: string;
    direction: string;
    source_name: string;
    source_session: string;
    color: string;
    created_at: string;
    updated_at: string;
    timestamp: string;
    seasonal_potential_range_upper: number;
    seasonal_potential_range_lower: number;
    seasonal_potential_probability: number;
    posts: Post[];
}

export type SignalSharingFilters = {
    date_upper?: string;
    date_lower?: string;
    signal_name?: string;
    group?: number;
    author?: number;
    symbol?: string;
    user?: number;
    webinar?: number;
};

interface GetSignalFilterValuesResponse extends GetFilterValuesResponse {
    signal_names: SignalNameFilter[];
}

export interface SignalNameFilter {
    signal_name: string;
}

export class SignalSharingStore extends AbstractSocialTradingStore<SignalInterface, SignalSharingFilters> {
    signalNames: IObservableArray<SignalNameFilter> = observable.array();

    createPaginatedDataStore(): PaginatedDataStore<SignalInterface, SignalSharingFilters> {
        return new PaginatedDataStore<SignalInterface, SignalSharingFilters>(async (page, filters) => {
            const { data } = await request.get<PaginationInterface<SignalInterface>>(
                '/api/v2.0/signal-sharing/signals',
                {
                    params: {
                        page,
                        ...(filters.date_upper && { date_upper: filters.date_upper }),
                        ...(filters.date_lower && { date_lower: filters.date_lower }),
                        ...(filters.group && { group: filters.group }),
                        ...(filters.signal_name && { signal_name: filters.signal_name }),
                        ...(filters.symbol && { symbol: filters.symbol }),
                        ...(filters.user && { user: filters.user }),
                        ...(filters.author && { author: filters.author }),
                        ...(filters.webinar && { webinar: filters.webinar }),
                    },
                }
            );

            return {
                hasNextPage: page < data.last_page,
                data: data.data,
            };
        });
    }

    async fetchFilterOptions(): Promise<GetSignalFilterValuesResponse> {
        const { data } = await request.get<GetSignalFilterValuesResponse>('/api/v2.0/signal-sharing/filter-values');
        runInAction(() => {
            this.signalNames.replace(data.signal_names);
        });
        return data;
    }
}

export const signalSharingStore = new SignalSharingStore();
